import React, { useEffect, useRef, useState } from 'react'
import Chart from "react-apexcharts";
import './LineChart.scss'
import { useTranslation } from "react-i18next";
var _ = require('lodash');

function CustomBarChart(props) {
  const { t } = useTranslation();
  const [series, setSeries] = useState(props.series);
  const [options,setOptions] = useState({});
  const [width, setWidth] = useState(props.width);
  const [height,setHeight] = useState(props.height);
  let isValid = useRef(false);
  
  const prepareOptions = (data) => {
    const {
      series,
      labelDisabled,
      xAxisDisabled,
      yAxisDisabled,
      labels,
      isStacked,
      ylabelSuffix,
      width,
      showTooltipTitle,
      title,
      isHorizontal,
      xlabelSuffix,
      xAxisTitle,
      legendPosition,
      yAxisTitle,
      fillColors
    } = data;

    let updatedSeries = [];
    series.forEach(el => {
      const validData = _.filter(el.data, (value)=>{
        return _.isNumber(value) && !_.isNaN(value);
      });
      updatedSeries.push({
        name:el.name,
        data:validData
      })
    });
    const onlyValues = _.uniq(_.flatten(_.map(updatedSeries,'data')));
    updatedSeries.forEach(el => {
      if(!_.isEmpty(el.data)){
        isValid.current = true;
      }
    });

    let options ={
      legend:{
        position : legendPosition ? legendPosition : 'bottom'
      },
      chart: {
        id: "basic-bar",
        toolbar:{
          show:false
        },
        type:'bar',
        stacked:isStacked?true:false
      },
      dataLabels:{
        enabled: labelDisabled ? false : true,
        formatter: function (val, opts) {
          return val
        },
        textAnchor: 'middle',
        distributed: false,
        style: {
          fontSize: '10px',
        }
      },
      yaxis:{
        show: yAxisDisabled ? false : true,
        labels:{
          formatter: function(val) {
                return ylabelSuffix ? `${val}${ylabelSuffix}` : val;
              }
        },
        title:{
          text: yAxisTitle ? yAxisTitle : "",
          style: {
            color: '#002E5B',
            fontSize: '12px',
            fontWeight: 600,
          },
        }
      },
      xaxis:{
        categories:labels,
        labels:{
          show: xAxisDisabled ? false : true,
          formatter: function (val, index) {
            return xlabelSuffix ? `${val}${xlabelSuffix}` : val;
          },
          hideOverlappingLabels: true
        },
        title:{
          text: xAxisTitle ? xAxisTitle : "",
          style: {
            color: '#002E5B',
            fontSize: '12px',
            fontWeight: 600,
          },
        }
        
      },
      plotOptions:{
        bar:{
          horizontal: isHorizontal ? true : false,
        }
      },
      tooltip:{
        enabled:true,
        y: {
          formatter: undefined,
          title: {
              formatter: (seriesName) => showTooltipTitle? seriesName : '',
          },
      }
      }
    }
    if(onlyValues.length === 1 && onlyValues[0]===0){
      options.yaxis.max = 1;
    }
    if (fillColors) {
      options.colors = fillColors;
      options.fill = {colors:fillColors};
    }

    if(title){
      options.title = {
        text:title,
        style:{
          fontWeight:600
        }
      };
    }
    setOptions(options);
    setSeries(updatedSeries); 
  }
 
 useEffect(() => {
    prepareOptions(props);
 }, [props]);
  
 return isValid.current ? 
          <Chart options={options} series={series} type="bar" width={ width ? width : 220} 
            height={ props.isStacked ? (height ? height : 300) : (height ? height : 150)}/> 
            :<div style={{"height": (props.isStacked ? (height ? height : 300) : (height ? height : 150))+'px'}} 
              className="cv-bar-chart fs12">{t("LT_no_data_available")}</div>;
}

export default CustomBarChart;
